import {createApp} from "petite-vue";

let map: google.maps.Map
export async function initMap() {
    const mapEl = document.querySelector('[data-map-holder]') as HTMLElement
    if (!mapEl) return

    const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

    const mapCenter = {lat: 49.83577267930496, lng: 18.155219887382238},
        themeRoot = mapEl.dataset.themeUri,
        compactView = window.innerWidth < 640

    map = new Map(mapEl, {
        center: mapCenter,
        zoom: compactView ? 13 : 14,
        gestureHandling: compactView ? "auto" : "none",
        zoomControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        styles: [
            {
                "featureType": "all",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry",
                "stylers": [
                    {
                        "weight": "0.5"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "lightness": "-50"
                    },
                    {
                        "saturation": "-50"
                    }
                ]
            },
            {
                "featureType": "administrative.neighborhood",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "hue": "#009aff"
                    },
                    {
                        "saturation": "25"
                    },
                    {
                        "lightness": "0"
                    },
                    {
                        "visibility": "simplified"
                    },
                    {
                        "gamma": "1"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "saturation": "0"
                    },
                    {
                        "lightness": "100"
                    },
                    {
                        "gamma": "2.31"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "simplified"
                    },
                    {
                        "lightness": "20"
                    },
                    {
                        "gamma": "1"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": "-100"
                    },
                    {
                        "lightness": "-100"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "lightness": "0"
                    },
                    {
                        "saturation": "45"
                    },
                    {
                        "gamma": "4.24"
                    },
                    {
                        "visibility": "simplified"
                    },
                    {
                        "hue": "#00ff90"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "saturation": "-100"
                    },
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "simplified"
                    },
                    {
                        "color": "#666666"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "saturation": "-25"
                    }
                ]
            },
            {
                "featureType": "transit.line",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "transit.station.airport",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": "50"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "lightness": "50"
                    },
                    {
                        "gamma": ".75"
                    },
                    {
                        "saturation": "-50"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            }
        ]
    });

    const marker = new google.maps.Marker({
        position: mapCenter,
        icon: `${themeRoot}/resources/images/map-logo.svg`,
        map: map
    });

    interface MapInterestPoints {
        popoverData?: pointDefinitions
        showPopover(pointDefinition: pointDefinitions): void
        hidePopover(): void
    }

    const locationWrapper = document.querySelector('[data-project-location]') as HTMLElement,
        popoverElement = locationWrapper?.querySelector('[popover]') as HTMLElement | null;

    const mapInterestPoints: MapInterestPoints = {
        popoverData: undefined,
        showPopover(pointDefinition) {
            this.popoverData = pointDefinition
            popoverElement.showPopover()
        },
        hidePopover() {
            popoverElement.hidePopover()
        }
    }

    const movePopover = (e: MouseEvent) => {
        let x: number, y: number

        try {
            x = e.pageX;
            y = e.pageY;
        } catch (e) {}

        popoverElement.style.setProperty('--popoverInset', `${y - 120}px auto auto ${x + 40}px`)
    };

    if (locationWrapper) {
        createApp(mapInterestPoints).mount(locationWrapper);
        locationWrapper.addEventListener("mousemove", e => movePopover(e));
    }

    const pointsDefinition = pointsDefinitions ?? [];

    const points = {
        hospital: [],
        school: [],
        service: [],
        activity: []
    }

    pointsDefinition.forEach(pointData => {
        const marker = new google.maps.Marker({
            map,
            position: pointData.position,
            icon: `${themeRoot}/resources/images/map-point.png`,
            optimized: true,
        });

        marker.addListener("mouseover",  () => {
            mapInterestPoints.showPopover(pointData);
        });
        marker.addListener("click",  () => {
            mapInterestPoints.showPopover(pointData);
        });

        marker.addListener("mouseout", () => {
            mapInterestPoints.hidePopover();
        });


        if (!points[pointData.category]) {
            points[pointData.category] = [];
        }

        points[pointData.category].push(marker);
    });

//-------Initial count
    const initialCounts = {};

    Object.keys(points).forEach(category => {
        initialCounts[category] = points[category].length; // Store initial counts
        const categoryButton = document.querySelector(`[data-category="${category}"] .count`);
        if (categoryButton) {
            categoryButton.textContent = `(${initialCounts[category]})`;
        }
    });

    document.querySelectorAll('[data-category]').forEach(toggle => {
        toggle.addEventListener('click', () => {
            const category = toggle.dataset.category;

            //----Toggle active state
            document.querySelectorAll('[data-category]').forEach(button => button.classList.remove('is-active'));
            toggle.classList.toggle('is-active');

            //---Show/hide interest points based on selection
            Object.keys(points).forEach(group => {
                points[group].forEach(point => point.setMap(null)); // Hide all points initially
                document.querySelectorAll(`.InterestPoint[data-category="${group}"]`).forEach(el => {
                    el.style.display = 'none'; // Hide all InterestPoints initially
                });
            });

            //--If a category is active, show only that category's points
            if (toggle.classList.contains('is-active')) {
                points[category].forEach(point => point.setMap(map));
                document.querySelectorAll(`.InterestPoint[data-category="${category}"]`).forEach(el => {
                    el.style.display = 'block';
                });
            } else {
                //---If no category is active, show all points
                Object.keys(points).forEach(group => {
                    points[group].forEach(point => point.setMap(map));
                    document.querySelectorAll(`.InterestPoint[data-category="${group}"]`).forEach(el => {
                        el.style.display = 'block';
                    });
                });
            }

            //---Update counts based on initial values
            Object.keys(initialCounts).forEach(cat => {
                const categoryButton = document.querySelector(`[data-category="${cat}"] .count`);
                if (categoryButton) {
                    categoryButton.textContent = `(${initialCounts[cat]})`; // Use stored initial counts
                }
            });
        });
    });

    map.addListener("tilesloaded", () => mapEl.classList.remove('is-loading'))
    //map.addListener("click", (mapsMouseEvent) => console.log(mapsMouseEvent.latLng.toJSON()));
}
